<div class="jdc-manager-container">
  @if (jdcInfo.loading) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
  </div>
}

  @if (!jdcInfo.loading) {
<div>
    <!-- Top-level tabs: Application / Application Settings -->
    <ul class="tab tab-pills">
      <li (click)="onJcdTabChange(1)"
          (mouseenter)="appTabHover = true" (mouseleave)="appTabHover = false">
        <a [ngClass]="{'activeTab': jcdTab === 1, 'inactiveTab': jcdTab !== 1 && appTabHover}">Application</a>
      </li>
      <li (click)="onJcdTabChange(2)"
          (mouseenter)="settingsTabHover = true" (mouseleave)="settingsTabHover = false">
        <a [ngClass]="{'activeTab': jcdTab === 2, 'inactiveTab': jcdTab !== 2 && settingsTabHover}">Application Settings</a>
      </li>
    </ul>
    <hr>

    @if (refreshTaskActivity) {
<div class="taskActivityOverlay">
      <div class="taskActivitySpinner">
        <i class="fa fa-spinner fa-spin" style="font-size: 36px;"></i>
      </div>
    </div>
}

    <form name="jdcManageFrm" (ngSubmit)="$event.preventDefault()" novalidate>

      <!-- ========== APPLICATION TAB ========== -->
      @if (jcdTab === 1) {
<div class="settings-list">
        <div class="app-toolbar">
          <div class="toolbar-left">
            <label class="toolbar-label">App Key:</label>
            @if (!jdcInfo.channelLoading) {
<select class="form-control toolbar-select" name="channel"
              [(ngModel)]="jdcInfo.selectedChannel" [ngModelOptions]="{standalone: true}"
              [disabled]="jdcInfo.resultLoading">
              @for (s of channelList; track $index) {
<option [ngValue]="s">{{ s.channel_name }}</option>
}
            </select>
}
            @if (!jdcInfo.resultLoading) {
<button type="button" class="btn btn-info action-btn" (click)="getResultForJDC()">Load</button>
}
            @if (jdcInfo.resultLoading) {
<div class="gt-filter-loading" style="margin-left: 10px;">
              <i class="fa fa-spinner fa-spin"></i>
            </div>
}
            <ul class="tab tab-pills sub-tabs toolbar-sub-tabs">
              <li (click)="tab = 0"
                  (mouseenter)="taxYearHover = true" (mouseleave)="taxYearHover = false">
                <a [ngClass]="{'activeTab': tab === 0, 'inactiveTab': tab !== 0 && taxYearHover}">Tax Years@if (jdcInfo.taxYear.taxYears.length > 0) {
<span class="badge"> ({{ jdcInfo.taxYear.taxYears.length }})</span>
}</a>
              </li>
              <li (click)="tab = 1"
                  (mouseenter)="scenarioHover = true" (mouseleave)="scenarioHover = false">
                <a [ngClass]="{'activeTab': tab === 1, 'inactiveTab': tab !== 1 && scenarioHover}">Scenarios@if (jdcInfo.scenario.scenarios.length > 0) {
<span class="badge"> ({{ jdcInfo.scenario.scenarios.length }})</span>
}</a>
              </li>
              <li (click)="tab = 4"
                  (mouseenter)="taskActivityHover = true" (mouseleave)="taskActivityHover = false">
                <a [ngClass]="{'activeTab': tab === 4, 'inactiveTab': tab !== 4 && taskActivityHover}">Tasks &amp; Activities</a>
              </li>
            </ul>
          </div>
          @if (tab === 0 || tab === 1) {
<div class="toolbar-right">
            <div class="searchDiv">
              <div class="searchBlock">
                <input type="text" class="contentSearch" [(ngModel)]="searchInput" name="searchInput" [ngModelOptions]="{standalone: true}" placeholder="Search">
              </div>
              <i class="fa fa-search searchIcons"></i>
            </div>
          </div>
}
        </div>

        <!-- Tax Years block -->
        @if (tab === 0) {
<div class="panel panel-default taxYearBlock">
          @if (jdcInfo.taxYear.taxYears.length > 0) {
<div class="panel-body taxYear customScroll" style="width: 100%;">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th style="vertical-align: middle;">Application TAX Year Key</th>
                  <th style="vertical-align: middle;">App Key</th>
                  <th style="vertical-align: middle;">Tax Year</th>
                  <th style="vertical-align: middle;">Edit Level</th>
                  <th style="vertical-align: middle;">Visible</th>
                  <th style="vertical-align: middle;">Default</th>
                  <th style="vertical-align: middle;">Access</th>
                  <th style="vertical-align: middle;">Remove/Save</th>
                </tr>
              </thead>
              <tbody>
                @for (ty of jdcInfo.taxYear.taxYears; track $index) {
<tr>
                  <td style="text-align: center;">{{ ty.jcd_tax_year_key }}</td>
                  <td>
                    <select class="form-control" [(ngModel)]="ty.channel" [name]="'channel_' + ty.jcd_tax_year_key">
                      @for (s of channelList; track $index) {
<option [ngValue]="s">{{ s.channel_name }}</option>
}
                    </select>
                  </td>
                  <td><input type="text" style="width: 90px;" [name]="'tax_year_' + ty.jcd_tax_year_key" [(ngModel)]="ty.tax_year" disabled></td>
                  <td>
                    <select [name]="'edit_level_' + ty.jcd_tax_year_key" class="form-control" [(ngModel)]="ty.edit_level">
                      @for (s of editlevelList.list; track $index) {
<option [ngValue]="s.value">{{ s.name }}</option>
}
                    </select>
                  </td>
                  <td>
                    <select [name]="'visible_' + ty.jcd_tax_year_key" class="form-control" [(ngModel)]="ty.visible">
                      @for (s of visibleList.list; track $index) {
<option [ngValue]="s.value">{{ s.name }}</option>
}
                    </select>
                  </td>
                  <td><i class="fa fa-check" style="font-size: 22px; cursor: pointer;" [ngClass]="{'default-yes': ty.is_default === '1', 'default-no': ty.is_default === '0'}" ap-tooltip [appendAfterTarget]="true" tooltipContent="Toggle default" direction="top" (click)="defaultTaxYear(ty)"></i></td>
                  <td><i class="fa" style="font-size: 22px; cursor: pointer;" [ngClass]="{'fa-lock': ty.is_locked === 'Y', 'fa-unlock': ty.is_locked === 'N'}" ap-tooltip [appendAfterTarget]="true" tooltipContent="Toggle access" direction="top" (click)="lockUnlockTaxYear(ty)"></i></td>
                  <td>
                    <i class="glyphicon glyphicon-trash color-red" style="cursor: pointer;" ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove Tax Year" direction="top"
                       (click)="askConfirmation('Remove Tax Year', 'Are you sure you want to remove this Tax Year ' + ty.jcd_tax_year_key + '?', removeTaxYear.bind(this, ty.jcd_tax_year_key))"></i>
                    @if (ty.editModalLoading) {
<i class="fa fa-spinner fa-spin"></i>
}
                    @if (!ty.editModalLoading) {
<i class="glyphicon glyphicon-floppy-save save-icon" style="margin-left: 10px; cursor: pointer;" ap-tooltip [appendAfterTarget]="true" tooltipContent="Save Tax Year" direction="top" (click)="editTaxYear(ty)"></i>
}
                  </td>
                </tr>
}
                <!-- New row -->
                <tr>
                  <td></td>
                  <td>
                    <select name="channel_new" class="form-control" [(ngModel)]="taxyear.channel" [compareWith]="compareChannel">
                      <option [ngValue]="null">-- Select App Key --</option>
                      @for (s of channelList; track $index) {
<option [ngValue]="s">{{ s.channel_name }}</option>
}
                    </select>
                  </td>
                  <td>
                    <input type="text" class="form-control" style="width: 90px;" name="tax_year_new"
                           placeholder="enter tax year" maxlength="4" inputmode="numeric" pattern="[0-9]*"
                           [ngModel]="taxyear.tax_year" (ngModelChange)="onNewTaxYearChange($event)">
                  </td>
                  <td>
                    <select name="edit_level_new" class="form-control" [(ngModel)]="taxyear.edit_level">
                      <option [ngValue]="null">-- Select Edit Level --</option>
                      @for (s of editlevelList.list; track $index) {
<option [ngValue]="s.value">{{ s.name }}</option>
}
                    </select>
                  </td>
                  <td>
                    <select name="visible_new" class="form-control" [(ngModel)]="taxyear.visible">
                      <option [ngValue]="null">-- Select Visible --</option>
                      @for (s of visibleList.list; track $index) {
<option [ngValue]="s.value">{{ s.name }}</option>
}
                    </select>
                  </td>
                  <td><i class="fa fa-check" style="font-size: 22px; cursor: pointer;" [ngClass]="{'default-yes': taxyear.is_default === '1', 'default-no': taxyear.is_default !== '1'}" ap-tooltip [appendAfterTarget]="true" tooltipContent="Toggle default" direction="top" (click)="toggleNewTaxYearDefault()"></i></td>
                  <td><i class="fa" style="font-size: 22px; cursor: pointer;" [ngClass]="{'fa-lock': taxyear.is_locked === 'Y', 'fa-unlock': taxyear.is_locked !== 'Y'}" ap-tooltip [appendAfterTarget]="true" tooltipContent="Toggle access" direction="top" (click)="toggleNewTaxYearLock()"></i></td>
                  <td>
                    @if (!taxyear.editModalLoading) {
<i class="glyphicon glyphicon-floppy-save save-icon" style="margin-left: 10px; cursor: pointer;" ap-tooltip [appendAfterTarget]="true" tooltipContent="Save New Tax Year" direction="top" (click)="addNewYear()"></i>
}
                    @if (taxyear.editModalLoading) {
<i class="fa fa-spinner fa-spin"></i>
}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
}
          @if (jdcInfo.taxYear.taxYears.length < 1) {
<div class="panel-body">
            <h4 class="error-label">Select App Key to get Tax Year</h4>
          </div>
}
        </div>
}

        <!-- Scenarios block -->
        @if (tab === 1) {
<div class="panel panel-default scenarioBlock">
          @if (jdcInfo.scenario.scenarios.length > 0) {
<div class="panel-body scenario customScroll">
            <table class="table custom-table">
              <thead>
                <tr>
                  <th style="width: 14%;">Tax Year</th><th style="width: 7%;">Scenario</th><th colspan="2">Scenario Description</th>
                  <th>Calendar Year</th><th>Calendar Month</th>
                  <th style="text-align: center;">Reporting?</th><th>Filing?</th>
                  <th>Default Scenario?</th><th>Visible</th><th>Access</th><th>Remove/Save</th>
                </tr>
              </thead>
              <tbody>
                @for (sc of jdcInfo.scenario.scenarios; track $index) {
<tr>
                  <td>
                    <select [name]="'sc_ty_' + sc.scenario" class="form-control" [(ngModel)]="sc.tax_year">
                      @for (s of taxyearList; track $index) {
<option [ngValue]="s.TAX_YEAR">{{ s.TAX_YEAR }}</option>
}
                    </select>
                  </td>
                  <td>{{ sc.scenario }}</td>
                  <td colspan="2"><input type="text" [name]="'sc_desc_' + sc.scenario" class="form-control" [(ngModel)]="sc.scenario_desc" style="width: 100%;"></td>
                  <td><input type="number" style="width: 100%;" [name]="'sc_cy_' + sc.scenario" class="form-control" [(ngModel)]="sc.calendar_year"></td>
                  <td><input type="number" style="width: 100%;" [name]="'sc_cm_' + sc.scenario" class="form-control" [(ngModel)]="sc.calendar_month"></td>
                  <td style="text-align: center;"><i class="fa fa-check" style="font-size: 22px; cursor: pointer;" [ngClass]="{'default-yes': sc.reporting_y_n === 'Y', 'default-no': sc.reporting_y_n === 'N'}" (click)="sc.reporting_y_n = sc.reporting_y_n === 'Y' ? 'N' : 'Y'; editScenario(sc)"></i></td>
                  <td><i class="fa fa-check" style="font-size: 22px; cursor: pointer;" [ngClass]="{'default-yes': sc.filing_y_n === 'Y', 'default-no': sc.filing_y_n === 'N'}" (click)="sc.filing_y_n = sc.filing_y_n === 'Y' ? 'N' : 'Y'; editScenario(sc)"></i></td>
                  <td><i class="fa fa-check" style="font-size: 22px; cursor: pointer;" [ngClass]="{'default-yes': sc.default_scenario === 'Y', 'default-no': sc.default_scenario === 'N'}" (click)="sc.default_scenario = sc.default_scenario === 'Y' ? 'N' : 'Y'; editScenario(sc)"></i></td>
                  <td><i class="fa fa-check" style="font-size: 22px; cursor: pointer;" [ngClass]="{'default-yes': sc.is_visible === 'Y', 'default-no': sc.is_visible === 'N'}" (click)="sc.is_visible = sc.is_visible === 'Y' ? 'N' : 'Y'; editScenario(sc)"></i></td>
                  <td><i class="fa" style="font-size: 22px; cursor: pointer;" [ngClass]="{'fa-lock': sc.is_locked === 'Y', 'fa-unlock': sc.is_locked === 'N'}" (click)="sc.is_locked = sc.is_locked === 'Y' ? 'N' : 'Y'; editScenario(sc)"></i></td>
                  <td>
                    <i class="glyphicon glyphicon-trash color-red" style="cursor: pointer;" ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove Scenario" direction="top"
                       (click)="askConfirmation('Remove Scenario', 'Are you sure you want to remove this Scenario ' + sc.scenario + '?', removeScenario.bind(this, sc.scenario))"></i>
                    <i class="glyphicon glyphicon-floppy-save save-icon" style="margin-left: 10px; cursor: pointer;" ap-tooltip [appendAfterTarget]="true" tooltipContent="Save Scenario" direction="top" (click)="editScenario(sc)"></i>
                  </td>
                </tr>
}
                <!-- New row -->
                <tr>
                  <td><select name="scenario_tax_year" class="form-control" [(ngModel)]="newScenario.tax_year">@for (s of taxyearList; track $index) {
<option [ngValue]="s?.TAX_YEAR">{{ s?.TAX_YEAR }}</option>
}</select></td>
                  <td><input type="number" style="width: 100%;" name="scenario_new" placeholder="Scenario" class="form-control" [(ngModel)]="newScenario.scenario"></td>
                  <td colspan="2"><input type="text" style="width: 100%;" name="scenario_desc_new" placeholder="Enter scenario Desc" class="form-control" [(ngModel)]="newScenario.scenario_desc"></td>
                  <td><input type="number" style="width: 100%;" name="calendar_year_new" class="form-control" [(ngModel)]="newScenario.calendar_year"></td>
                  <td><input type="number" style="width: 100%;" name="calendar_month_new" class="form-control" [(ngModel)]="newScenario.calendar_month"></td>
                  <td style="text-align: center;"><i class="fa fa-check" style="font-size: 22px"></i></td>
                  <td><i class="fa fa-check" style="font-size: 22px"></i></td>
                  <td><i class="fa fa-check" style="font-size: 22px"></i></td>
                  <td><i class="fa fa-check" style="font-size: 22px"></i></td>
                  <td><i class="fa fa-unlock" style="font-size: 22px"></i></td>
                  <td><i class="glyphicon glyphicon-floppy-save save-icon" style="cursor: pointer;" ap-tooltip [appendAfterTarget]="true" tooltipContent="Save New Scenario" direction="top" (click)="addNewScenario()"></i></td>
                </tr>
              </tbody>
            </table>
          </div>
}
          @if (jdcInfo.scenario.scenarios.length < 1) {
<div class="panel-body">
            <h4 class="error-label">Select App Key to get Scenarios.</h4>
          </div>
}
        </div>
}

        <!-- Tasks & Activities block -->
        @if (tab === 4) {
<div class="panel panel-default taskActivityBlock">
          @if (jdcInfo.taskActivity.taskActivities.length > 0) {
<div class="panel-body taskActivityInnerBlock">
            <div class="col-md-3 tasksPanel">
              <div class="row" style="padding-bottom: 5px; padding-top: 5px; margin: 0;">
                <div class="col-md-9">
                  <span class="bold_txt">Tasks</span>
                  <span class="pull-right search" style="position: relative;">
                    <input type="text" class="form-control" style="height: 22px; width: 156px; padding-right: 22px;" [(ngModel)]="searchText" name="searchText" [ngModelOptions]="{standalone: true}" placeholder="Task search">
                    <i class="fa fa-search" style="position: absolute; top: 5px; right: 5px;"></i>
                  </span>
                </div>
                <div class="col-md-3 no_left_padding no_right_padding" style="display: flex;">
                  <span class="reorderTask" ap-tooltip [appendAfterTarget]="true" tooltipContent="Reorder Tasks" direction="top" (click)="ReorderTasks()"><i class="fa fa-retweet"></i></span>
                  <span class="addNew" ap-tooltip [appendAfterTarget]="true" tooltipContent="Add New Task" direction="top" (click)="addNewTask()"><i class="fa fa-plus"></i></span>
                  @if (taskMoveActive) {
<span class="cancelMove" ap-tooltip [appendAfterTarget]="true" tooltipContent="Click to cancel operation" direction="top" (click)="cancelTaskMove()"><i class="fa fa-times"></i></span>
}
                </div>
              </div>
              <div class="col-border task-tree-scroll">
                @if (trees.nodes.length > 0) {
<div>
                  @for (node of trees.nodes; track $index) {

                    <ng-container *ngTemplateOutlet="taskNodeTpl; context: { $implicit: node, depth: 0 }"></ng-container>
                  
}
                </div>
}
              </div>
            </div>

            <!-- Recursive task node template -->
            <ng-template #taskNodeTpl let-node let-depth="depth">
              @if (matchesSearch(node)) {
<div
                   class="task_list"
                   [style.padding-left.px]="12 + depth * 16"
                   [ngClass]="{'selected': taskModel?.task_key === node.task_key, 'highlight-node': node.highlightNode, 'move-source': node.isMoveSelected}"
                   (mouseenter)="onTaskRowMouseEnter(node)"
                   (mouseleave)="onTaskRowMouseLeave(node)"
                   (click)="taskSelect(node, 'task'); $event.stopPropagation()">
                @if (node.sub_task?.length > 0) {
<span class="tree-toggle" (click)="toggleNode(node.task_key); $event.stopPropagation()">
                  <i class="fa" [ngClass]="isCollapsed(node.task_key) ? 'fa-folder' : 'fa-folder-open'"
                     [class.parent-folder]="depth === 0" [class.child-folder]="depth > 0"></i>
                </span>
}
                @if (!node.sub_task?.length && depth === 0) {
<span class="tree-toggle">
                  <i class="fa fa-folder-open parent-folder"></i>
                </span>
}
                @if (!node.sub_task?.length && depth > 0) {
<span class="tree-toggle">
                  <i class="fa fa-file-o child-folder"></i>
                </span>
}
                <span class="display_name">{{ node.task_name || node.name }}</span>
                <span class="node-tools pull-right">
                  @if (!taskMoveActive) {
<i class="fa fa-share move-icon"
                     ap-tooltip [appendAfterTarget]="true" tooltipContent="Click to move" direction="left"
                     (click)="startTaskMove(node); $event.stopPropagation()"></i>
}
                  @if (taskMoveActive && node.isMoveSelected) {
<i class="fa fa-times move-cancel-icon"
                     ap-tooltip [appendAfterTarget]="true" tooltipContent="Click to cancel operation" direction="left"
                     (click)="cancelTaskMove(); $event.stopPropagation()"></i>
}
                  @if (taskMoveActive && node.dropIcon && !node.nodeToMove) {
<i class="glyphicon glyphicon-inbox drop-icon"
                    
                     ap-tooltip [appendAfterTarget]="true" tooltipContent="Click to drop" direction="left"
                     (click)="confirmDropTask(node); $event.stopPropagation()"></i>
}
                </span>
              </div>
}
              @if (node.sub_task?.length > 0 && !isCollapsed(node.task_key)) {
<div>
                @for (child of node.sub_task; track $index) {

                  <ng-container *ngTemplateOutlet="taskNodeTpl; context: { $implicit: child, depth: depth + 1 }"></ng-container>
                
}
              </div>
}
            </ng-template>

            <!-- Task details + activities -->
            <div class="col-md-9">
              <div class="row" style="padding: 5px 0;">
                <div class="col-md-12"><span class="bold_txt">Task Details</span></div>
              </div>
              <div class="row">
                <div class="col-md-5">
                  <div class="col-md-3 no_left_padding"><span>App Key</span></div>
                  <div class="col-md-9 no_left_padding" style="margin-bottom: 12px;">
                    <select class="form-control input-sm" name="channel_task" [(ngModel)]="selectedTask.channel" (ngModelChange)="onTaskChanged()">
                      @for (s of channelList; track $index) {
<option [ngValue]="s">{{ s.channel_name }}</option>
}
                    </select>
                  </div>
                  <div class="col-md-3 no_left_padding"><span>Name</span></div>
                  <div class="col-md-9 no_left_padding" style="margin-bottom: 12px;">
                    <input type="text" name="task_name" class="form-control input-sm" placeholder="Task Name" [(ngModel)]="selectedTask.task_name" (ngModelChange)="onTaskChanged()">
                  </div>
                  <div class="col-md-3 no_left_padding"><span>Status</span></div>
                  <div class="col-md-5 no_left_padding" style="margin-bottom: 12px; padding-right: 0;">
                    <label class="radio-inline"><input type="radio" name="status" [value]="'A'" [(ngModel)]="selectedTask.task_status" (change)="onTaskChanged()">Active</label>
                    <label class="radio-inline"><input type="radio" name="status" [value]="'I'" [(ngModel)]="selectedTask.task_status" (change)="onTaskChanged()">Inactive</label>
                  </div>
                  <div class="col-md-4 no_right_padding no_left_padding" style="display: flex;">
                    @if (!isAppParentChanged) {
<span class="addNew" style="background-color: hsl(195deg 53% 79%); cursor: not-allowed;" ap-tooltip [appendAfterTarget]="true" tooltipContent="No changes to Save" direction="top">
                      <i class="fa fa-floppy-o"></i>
                    </span>
}
                    @if (isAppParentChanged) {
<span class="addNew" style="background-color: hsl(194deg 66% 51%);" (click)="saveTaskDetails(selectedTask?.task_key ? 'edit' : 'new')" ap-tooltip [appendAfterTarget]="true" tooltipContent="Save Task" direction="top">
                      <i class="fa fa-floppy-o"></i>
                      @if (saveTaskLoader) {
<i class="fa fa-spinner fa-spin saveTaskLoader"></i>
}
                    </span>
}
                    @if (selectedTask?.task_key) {
<i class="fa fa-minus-circle taskDelete" ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove Task" direction="top"
                       (click)="askConfirmation('Remove Task', 'Are you sure you want to remove this task?', removeTask.bind(this, selectedTask.task_key))"></i>
}
                    @if (isAppParentChanged) {
<span class="resetTask" style="background-color: hsl(39deg 100% 50%);" ap-tooltip [appendAfterTarget]="true" tooltipContent="Reset Changes" direction="top" (click)="resetTaskDetails()">
                      <i class="fa fa-window-restore"></i>
                    </span>
}
                  </div>
                </div>
                <div class="col-md-5">
                  <div class="col-md-3 no_left_padding no_right_padding"><span>Parent Name</span></div>
                  <div class="col-md-9" style="margin-bottom: 12px;">
                    <select name="parentTask" class="form-control input-sm" [(ngModel)]="selectedTask.parentTask" (ngModelChange)="onTaskChanged()">
                      <option value="">none</option>
                      @for (task of taskList; track $index) {
<option [ngValue]="task.task_key">{{task.indent}}{{task.task_name}}</option>
}
                    </select>
                  </div>
                  <div class="col-md-3 no_left_padding"><span>Description</span></div>
                  <div class="col-md-9" style="margin-bottom: 12px;"><textarea name="task_desc" class="form-control input-sm" rows="3" cols="40" [(ngModel)]="selectedTask.task_desc" (ngModelChange)="onTaskChanged()"></textarea></div>
                </div>
              </div>

              <div class="row" style="margin-bottom: 4px;">
                <div class="col-md-6">
                  <div class="col-md-4 no_left_padding no_right_padding">
                    <span class="bold_txt">Related Activities</span>
                  </div>
                  <div class="col-md-6" style="display: flex;">
                    <span class="addNew" ap-tooltip [appendAfterTarget]="true" tooltipContent="Add New Activity" direction="top" (click)="addNewActivity()"><i class="fa fa-plus"></i></span>
                  </div>
                </div>
                <div class="col-md-6 no_right_padding">
                  <div class="col-md-12 no_right_padding activity-legend">
                    <span class="legend status_active"></span>Active
                    <span class="legend status_maintenance"></span>Maintenance
                    <span class="legend status_locked"></span>Locked
                    <span class="legend status_removed"></span>Removed
                  </div>
                </div>
              </div>

              <div class="row activities_block">
                @if (activitiesList.length > 0) {
<div class="col-md-12 main-header">
                  <div class="col-sm-1 no_right_padding"><span style="margin-left: 23px;">Key</span></div>
                  <div class="col-sm-2"><span>Name</span></div>
                  <div class="col-sm-1 no_left_padding"><span>Roles</span></div>
                  <div class="col-sm-1 no_left_padding"><span>Edit Level</span></div>
                  <div class="col-sm-1 text-center"><span>Start</span></div>
                  <div class="col-sm-1 no_right_padding text-center"><span>Tax Types</span></div>
                  <div class="col-sm-1 text-center"><span>End</span></div>
                  <div class="col-sm-1 text-center"><span>Status</span></div>
                  <div class="col-sm-1 no_left_padding text-center"><span>Screens</span></div>
                  <div class="col-sm-1 no_left_padding"></div>
                </div>
}
                <div class="col-md-12 main-body customScroll">
                  <ul class="no_left_padding" cdkDropList [cdkDropListData]="activitiesList" (cdkDropListDropped)="dropActivities($event)">
                    @for (activity of activitiesList; track $index) {
<li class="col-md-12 activityRow" cdkDrag>
                      <div class="col-sm-1 no_right_padding" cdkDragHandle style="cursor: move;">
                        <span class="fa fa-ellipsis-v"></span>
                        <span class="fa fa-ellipsis-v"></span>
                        <span style="margin-left: 10px;">{{activity.activity_key}}</span>
                      </div>
                      <div class="col-sm-2"><span>{{activity.activity_name}}</span></div>
                      <div class="col-sm-1 no_left_padding">
                        <span style="cursor: pointer;"
                              ap-tooltip [appendAfterTarget]="true" [tooltipContent]="buildTooltipList(activity.roles, 'No Roles')"
                              direction="top" [tooltipStyleClass]="'gtw-tooltip-multiline'"><i class="fa fa-user-plus"></i></span>
                        @if (activity.roles?.length > 0) {
<i style="margin-left:6px; cursor: pointer;" class="fa fa-clipboard" ap-tooltip [appendAfterTarget]="true" tooltipContent="Copy Access" direction="top"
                           (click)="copyAccessRoles(activity)"></i>
}
                        @if (activity.roles?.length > 0) {
<i style="margin-left:6px; cursor: pointer;" class="fa fa-users" ap-tooltip [appendAfterTarget]="true" tooltipContent="User List" direction="top"
                           (click)="getActivityUsers(activity)"></i>
}
                      </div>
                      <div class="col-sm-1 no_left_padding"><span>Open All</span></div>
                      <div class="col-sm-1 text-center"><span>{{formatDate(activity.start_date)}}</span></div>
                      <div class="col-sm-1 no_right_padding text-center">
                        <span style="cursor: pointer;">
                          <i class="fa fa-file-text-o"
                             ap-tooltip [appendAfterTarget]="true" [tooltipContent]="buildTooltipList(activity.taxtypeList, 'No Tax Types')"
                             direction="top" [tooltipStyleClass]="'gtw-tooltip-multiline'"></i>
                        </span>
                      </div>
                      <div class="col-sm-1 text-center"><span>{{formatDate(activity.end_date)}}</span></div>
                      <div class="col-sm-1 text-center">
                        <span class="act_status" [ngClass]="{'status_active': activity.activity_status == 'A', 'status_locked': activity.activity_status == 'L', 'status_removed': activity.activity_status == 'R', 'status_maintenance': activity.activity_status == 'M'}">{{activity.activity_status}}</span>
                      </div>
                      <div class="col-sm-1 no_left_padding text-center">
                        <span style="cursor: pointer;">
                          <i class="fa fa-list-alt"
                             ap-tooltip [appendAfterTarget]="true" [tooltipContent]="buildTooltipList(activity.screens, 'No Screens')"
                             direction="top" [tooltipStyleClass]="'gtw-tooltip-multiline'"></i>
                        </span>
                      </div>
                      <div class="col-sm-1 no_left_padding no_right_padding">
                        <i style="font-size:22px; cursor: pointer;" class="fa fa-minus-circle color-red" ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove Activity" direction="top"
                           (click)="askConfirmation('Remove Activity', 'Are you sure you want to remove this activity?', removeActivity.bind(this, activity.activity_key, jdcInfo.jcdKey))"></i>
                        <i style="font-size:18px; margin-left:10px; cursor: pointer;" class="glyphicon glyphicon-pencil" ap-tooltip [appendAfterTarget]="true" tooltipContent="Edit Activity" direction="top" (click)="editActivity(activity)"></i>
                      </div>
                    </li>
}
                    @if (activitiesList.length < 1) {
<div class="noActivities">
                      No Activities to display or you do not have access to the Activities.
                    </div>
}
                  </ul>
                </div>
              </div>
            </div>
          </div>
}
          @if (jdcInfo.taskActivity.taskActivities.length < 1) {
<div class="panel-body">
            <h4 class="error-label">Select App Key and load Tax Years / Scenarios to manage Tasks &amp; Activities.</h4>
          </div>
}
        </div>
}
      </div>
}

      <!-- ========== APPLICATION SETTINGS TAB ========== -->
      @if (jcdTab === 2) {
<div class="settings-list">
        @if (jdcSettingsLoading) {
<div class="formLoader">
          <i class="fa fa-spinner fa-spin" style="color: #e12827; font-size: 24px;"></i>
        </div>
}
        @if (!jdcSettingsLoading) {
<div>
          <div class="panel panel-default">
            <div class="panel-heading panel-heading-flex">
              <b>TGT Application ASSIGN ({{jcdCombiList.length}})</b>
              <div class="panel-heading-actions">
                <button type="button" class="btn btn-success action-btn" (click)="openAddJcdModal()">Add Application Assign</button>
                <i class="glyphicon" [ngClass]="{'glyphicon-chevron-down': showJcds, 'glyphicon-chevron-up': !showJcds}" style="cursor: pointer;" ap-tooltip [appendAfterTarget]="true" [tooltipContent]="showJcds ? 'Collapse' : 'Expand'" direction="top" (click)="toggleJcdComb()"></i>
              </div>
            </div>
            @if (showJcds && jcdCombiList.length > 0) {
<table class="table custom-table">
              <thead>
                <tr><th>Application Key</th><th>Jurisdiction Code</th><th>Domain Name</th><th>Channel Name</th><th>Client Name</th><th></th></tr>
              </thead>
              <tbody>
                @for (jcds of jcdCombiList; track $index) {
<tr>
                  <td>{{jcds.jcd_key}}</td><td>{{jcds.jurisdiction_code}}</td><td>{{jcds.domain_name}}</td>
                  <td>{{jcds.channel_name}}</td><td>{{jcds.client_name}}</td>
                  <td>
                    <i style="font-size:18px; cursor: pointer; margin-right: 10px;" class="glyphicon glyphicon-pencil" ap-tooltip [appendAfterTarget]="true" tooltipContent="Edit JCD" direction="top" (click)="editJCD(jcds)"></i>
                    <i style="font-size:24px; cursor: pointer;" class="fa fa-minus-circle color-red" ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove JCD" direction="top"
                       (click)="askConfirmation('Remove JCD_KEY', 'Are you sure you want to remove this JCD KEY ' + jcds.jcd_key + '?', removeJCD.bind(this, jcds))"></i>
                  </td>
                </tr>
}
              </tbody>
            </table>
}
            @if (showJcds && jcdCombiList.length === 0) {
<div class="panel-body">
              <span>No Application Combination found</span>
            </div>
}
          </div>

          <div class="panel panel-default">
            <div class="panel-heading panel-heading-flex">
              <b>Channel ({{channelList.length}})</b>
              <div class="panel-heading-actions">
                <button type="button" class="btn btn-success action-btn" (click)="addNewChannel()">Add New Channel</button>
                <i class="glyphicon" [ngClass]="{'glyphicon-chevron-down': showChannels, 'glyphicon-chevron-up': !showChannels}" style="cursor: pointer;" ap-tooltip [appendAfterTarget]="true" [tooltipContent]="showChannels ? 'Collapse' : 'Expand'" direction="top" (click)="toggleChannels()"></i>
              </div>
            </div>
            @if (showChannels && channelList.length > 0) {
<table class="table custom-table">
              <thead>
                <tr><th>Channel Key</th><th>Channel Name</th><th>Channel Description</th><th>Channel Priority</th><th>Channel Status</th><th>Client Key</th><th></th></tr>
              </thead>
              <tbody>
                @for (channel of channelList; track $index) {
<tr>
                  <td>{{channel.channel_key}}</td><td>{{channel.channel_name}}</td><td>{{channel.channel_desc}}</td>
                  <td>{{channel.channel_priority}}</td><td>{{channel.channel_status}}</td><td>{{channel.client_key}}</td>
                  <td>
                    <i style="font-size:18px; cursor: pointer; margin-right: 10px;" class="glyphicon glyphicon-pencil" ap-tooltip [appendAfterTarget]="true" tooltipContent="Edit Channel" direction="top" (click)="editChannel(channel)"></i>
                    <i style="font-size:24px; cursor: pointer;" class="fa fa-minus-circle color-red" ap-tooltip [appendAfterTarget]="true" tooltipContent="Remove Channel" direction="top"
                       (click)="askConfirmation('Remove Channel', 'Are you sure you want to remove this Channel ' + channel.channel_key + '?', removeChanel.bind(this, channel.channel_key))"></i>
                  </td>
                </tr>
}
              </tbody>
            </table>
}
            @if (showChannels && channelList.length === 0) {
<div class="panel-body">
              <span>No Channels found</span>
            </div>
}
          </div>
        </div>
}
      </div>
}
    </form>

    <!-- ========== MODALS ========== -->

    <!-- Confirmation Modal -->
    @if (showConfirmModal) {
<div class="modal-overlay" (click)="cancelConfirm()">
      <div (click)="$event.stopPropagation()">
        <gtw-confirmation-modal
          [config]="confirmModalConfig"
          [visible]="false"
          (confirmed)="executeConfirm()"
          (cancelled)="cancelConfirm()"
          (closed)="cancelConfirm()">
        </gtw-confirmation-modal>
      </div>
    </div>
}

    <!-- Reorder Tasks Modal -->
    @if (showReorderModal) {
<gtw-jdc-tasks-reorder-modal
     
      [treeNodes]="trees.nodes"
      [jcdKey]="jdcInfo.jcdKey"
      [clientKey]="clientKey"
      (applied)="showReorderModal = false; getResultForJDC()"
      (closed)="showReorderModal = false">
    </gtw-jdc-tasks-reorder-modal>
}

    <!-- Copy Access Modal -->
    @if (showCopyAccessModal) {
<gtw-jdc-copy-roles-access-modal
     
      [treeNodes]="trees.nodes"
      [jcdKey]="jdcInfo.jcdKey"
      [clientKey]="clientKey"
      [globalParams]="globalParams"
      [targetActivity]="copyAccessTargetActivity"
      (saved)="showCopyAccessModal = false"
      (closed)="showCopyAccessModal = false">
    </gtw-jdc-copy-roles-access-modal>
}

    <!-- Activity Users Modal -->
    @if (showActivityUsersModal) {
<gtw-jdc-activity-user-list-modal
     
      [activityKey]="activityUsersActivityKey"
      [jcdKey]="jdcInfo.jcdKey"
      [clientKey]="clientKey"
      [globalParams]="globalParams"
      (closed)="showActivityUsersModal = false">
    </gtw-jdc-activity-user-list-modal>
}

    <!-- New JCD KEY Modal -->
    @if (showAddJcdModal) {
<gtw-jdc-new-key-modal
     
      [mode]="jcdModalMode"
      [jcdData]="jcdModalData"
      [clientKey]="clientKey"
      [client]="client"
      [channelList]="channelList"
      [jcdCombiList]="jcdCombiList"
      (saved)="showAddJcdModal = false; settingsLoaded = false; loadResultForJDCSettings()"
      (closed)="showAddJcdModal = false">
    </gtw-jdc-new-key-modal>
}

    <!-- Save/Edit Channel Modal -->
    @if (showChannelModal) {
<gtw-jdc-channel-modal
     
      [mode]="channelModalMode"
      [channelData]="channelModalData"
      [clientKey]="clientKey"
      [channelList]="channelList"
      (saved)="showChannelModal = false; loadResultForJDCSettings()"
      (closed)="showChannelModal = false">
    </gtw-jdc-channel-modal>
}

    <!-- Save Task Modal -->
    @if (showTaskModal) {
<gtw-jdc-save-task-modal
     
      [mode]="taskModalMode"
      [rowData]="null"
      [channelList]="channelList"
      [taskList]="taskList"
      [jcdKey]="jdcInfo.jcdKey"
      [clientKey]="clientKey"
      [selectedChannel]="jdcInfo.selectedChannel"
      [client]="client"
      (saved)="showTaskModal = false; getResultForJDC()"
      (closed)="showTaskModal = false">
    </gtw-jdc-save-task-modal>
}

    <!-- Save Activity Modal -->
    @if (showActivityModal) {
<gtw-jdc-save-activity-modal
     
      [mode]="activityModalMode"
      [activityData]="activityModalData"
      [channelList]="channelList"
      [taskList]="taskList"
      [jcdKey]="jdcInfo.jcdKey"
      [clientKey]="clientKey"
      [selectedChannel]="jdcInfo.selectedChannel"
      [globalParams]="globalParams"
      [selectedTask]="selectedTask"
      [client]="client"
      (saved)="showActivityModal = false; getResultForJDC()"
      (closed)="showActivityModal = false">
    </gtw-jdc-save-activity-modal>
}
  </div>
}
</div>
